import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { WorkflowService } from 'src/app/service/workflow/workflow.service';
import { DataService } from 'src/app/service/data.service';

@Component({
  selector: 'workflow-header',
  templateUrl: './workflow-header.component.html',
  styleUrls: ['./workflow-header.component.less']
})
export class WorkflowHeaderComponent extends BaseComponent implements OnInit {

  constructor(dataService:DataService, private workflowService: WorkflowService) {
    super(dataService);
  }

  private workflowTitle: string = "";

  ngOnInit() {
   

    // listener for change of workflow title
    this.workflowService.currentWorkflowName.subscribe(name => {
      this.workflowTitle = name;
    });    
  }

  onSave(){    
  }

}
